import Loader from "components/Loader";
import {connect} from 'react-redux';


const mapStateToProps = ({loader: {loader}}) => ({
  visible: loader
});

export default connect(mapStateToProps)(Loader);
